import { getStore } from '@/util/store'
const accessInfo = getStore({ name: 'accessInfo' }) || {}
const userInfo = getStore({ name: 'userInfo' }) || {}
const sendTrack = (eventCode) => {
  const { schoolDetails } = userInfo
  const { user_id, memberType } = accessInfo
  // 多值为老师 否则是学生
  const identity = memberType?.length === 1 && memberType[0] === 'student' ? '学生' : '教师'

  window.$wujie?.props.sendEvent([
    {
      eventCode: eventCode,
      eventTime: new Date().getTime(),
      userId: user_id,
      identity: identity,
      customParam: JSON.stringify({
        schoolId: schoolDetails && schoolDetails[0] ? schoolDetails[0]?.schoolId : '',

        schoolName: schoolDetails && schoolDetails[0] ? schoolDetails[0]?.schoolName : '',
      }),
    },
  ])
}

export default sendTrack
